import { IconTriangleRight } from "@suse-o11y/icons";
import React, { type FC } from "react";
import { useDispatch } from "react-redux";

import { Mode } from "~/models/dto";

import { usageTrack } from "../../../app/state/usage-track/UsageTrackActions";
import { Button } from "../buttons/Button";

const watchTutorialLink = "https://youtu.be/I0SExWGjvQg?si=KzptfxszN0qNR7wM";

export const UpgradeButton: FC = () => {
	const dispatch = useDispatch();

	return (
		<Button
			className="h-7"
			compact
			data-testid="upgrade-button"
			data-trackid="tm-tryfree-button"
			icon={<IconTriangleRight />}
			onClick={() => {
				dispatch(usageTrack({ name: "NUMBER_OF_CTA_CLICKS", value: 1, mode: Mode.Increment }));
				dispatch(usageTrack({ name: "PLAYGROUND_TRY_FREE_BUTTON", value: "top-nav", mode: Mode.Set }));
				open(watchTutorialLink, "_blank");
			}}
			title="Watch the tutorial"
		>
			Watch the tutorial
		</Button>
	);
};
